module.exports = __webpack_public_path__ + "img/main_hlw.6334bf5e.jpg";